import { render, staticRenderFns } from "./Consolidatedprintsettings.vue?vue&type=template&id=a237034e&scoped=true&"
import script from "./Consolidatedprintsettings.vue?vue&type=script&lang=js&"
export * from "./Consolidatedprintsettings.vue?vue&type=script&lang=js&"
import style0 from "./Consolidatedprintsettings.vue?vue&type=style&index=0&id=a237034e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a237034e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a237034e')) {
      api.createRecord('a237034e', component.options)
    } else {
      api.reload('a237034e', component.options)
    }
    module.hot.accept("./Consolidatedprintsettings.vue?vue&type=template&id=a237034e&scoped=true&", function () {
      api.rerender('a237034e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Consolidatedprintsettings.vue"
export default component.exports